import React from 'react';
import { Typography, Box } from '@mui/material';

const ROLE_HINTS = {
    admin: 'Full system access — financial, resource, and admin modules.',
    director: 'Executive view — portfolio health, financial KPIs, and approvals.',
    ceo: 'Executive view — portfolio health, financial KPIs, and approvals.',
    cto: 'Executive view — portfolio health, financial KPIs, and approvals.',
    cfo: 'Executive view — portfolio health, financial KPIs, and approvals.',
    project_manager: 'Delivery focus — projects, staffing, timesheets, and tasks.',
    manager: 'Delivery focus — projects, staffing, timesheets, and tasks.',
    employee: 'Contributor view — timesheets, tasks, and assigned projects.',
};

/**
 * Role-based navigation hint (design-review #13).
 *
 * @param {object} props
 * @param {string} [props.role] - User role slug
 */
const NavRoleHint = ({ role = null }) => {
    const hint = ROLE_HINTS[role] || 'Modules shown match your role and permissions.';

    return (
        <Box data-testid="nav-role-hint" sx={{ px: 2, py: 1 }}>
            <Typography variant="caption" color="text.secondary" display="block">
                {hint}
            </Typography>
        </Box>
    );
};

export default NavRoleHint;
